export default __webpack_public_path__ + "static/media/(77).c46ede5d.jpg";